import { useMemo } from "react";
import { useCan } from "./useCan";
import { usePermissions } from "../context/PermissionContext";

/**
 * Shared crew vs office/admin profile detection.
 * Prefer permission flags over brittle role-name string checks.
 */
export const useCrewProfile = () => {
    const { roleName } = usePermissions();
    const adminPerm = useCan("superadmin.dashboard");
    const crewPerm = useCan("crew.dashboard");

    return useMemo(() => {
        const isCrewProfile =
            !adminPerm.canView &&
            (crewPerm.canView || String(roleName || "").toLowerCase() === "crew");

        return {
            isCrewProfile,
            isOfficeUser: !isCrewProfile,
            roleName,
            adminPerm,
            crewPerm,
        };
    }, [adminPerm.canView, crewPerm.canView, roleName]);
};

export default useCrewProfile;
